import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import { fetchMetacriticNewReleases } from 'Redux/ducks/algolia-calls';
import ProductListCard from 'Components/Cards/ProductListCard';

function MetacriticNewReleasesContainer({ siteTheme, listCardNameTag, loadedHits, hitsToDisplay }) {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const fetchHits = async () => {
      let hitsToSet;

      if (!isEmpty(loadedHits)) {
        hitsToSet = loadedHits;
      } else {
        hitsToSet = await fetchMetacriticNewReleases();
      }

      const metacriticHitsDesc = hitsToSet.filter(game => !game.parent_slug || (game.display_type === 'dlc' && game.parent_slug)).sort(
        (a, b) => b.metacritic_score - a.metacritic_score,
      );
      setHits(metacriticHitsDesc);
    };

    fetchHits();
  }, [loadedHits]);

  let metacriticLogoSrc = 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-full-white.svg';
  if (siteTheme === 'light') metacriticLogoSrc = 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-full-black.svg';

  return (
    <div>
      <h2 className="mb-3 h3 metacritic-list-title">
        <FormattedMessage id="metacritic-new-releases-list.title" defaultMessage="Top Reviewed on" />
        <div className="svg-container">
          <img src={metacriticLogoSrc} alt="Metacritic" />
        </div>
      </h2>
      <ol className="product-list-card-list">
        {hits && hits.slice(0, hitsToDisplay).map((hit, i) =>
          <ProductListCard
            showReleaseDate
            isMetacritic
            hit={hit}
            index={i}
            key={hit.objectID}
            listCardNameTag={listCardNameTag}
            listCardContainerTag="li"
          />,
        )}
        {isEmpty(hits) && [...Array(hitsToDisplay).keys()].map(i =>
          <ProductListCard index={i} key={i} listCardContainerTag="li" />,
        )}
      </ol>
    </div>
  );
}

MetacriticNewReleasesContainer.propTypes = {
  siteTheme: PropTypes.string,
  listCardNameTag: PropTypes.string,
  loadedHits: PropTypes.arrayOf(PropTypes.object),
  hitsToDisplay: PropTypes.number,
};

MetacriticNewReleasesContainer.defaultProps = {
  siteTheme: '',
  listCardNameTag: 'div',
  loadedHits: [],
  hitsToDisplay: 10,
};

const mapStateToProps = ({
  router: {
    location,
  },
  siteTheme,
}) => ({ location, siteTheme });

export default connect(mapStateToProps)(MetacriticNewReleasesContainer);
